define('SageDotCom/Utility/consumableArray',[],function () {

    function _toConsumableArray(arr) {
        if ($.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                arr2[i] = arr[i];
            } return arr2;
        } else {
            return Array.from(arr);
        }
    };

        return {
            _toConsumableArray: _toConsumableArray
        }
});





